import React from "react";
import Card from "react-bootstrap/Card";
import { useInView } from "react-intersection-observer";
import "./StreamCard.css";

function StreamCard({ featuredImageUrl, title }) {
      const { ref, inView } = useInView({
          triggerOnce: true, // Only trigger once
          threshold: 0, // 1% of the image must be in view
      });
    const decodeHTMLEntities = (html) => {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    };
    const decodedTitle = decodeHTMLEntities(title);

    return (
        <Card className="stream-card">
            {!inView && (
                <div
                    className="animated-bg"
                    style={{ height: "130px" }}
                ></div>
            )}
            <div ref={ref}>
                {/* Load image when it comes into view */}
                {inView && (
                    <Card.Img
                        variant="top"
                        src={featuredImageUrl}
                        alt={decodedTitle}
                        className="lazy-image"
                    />
                )}
            </div>
            <Card.Body className="border-top">
                <Card.Title
                    className="text-center ccl-blue fw-bold"
                    dangerouslySetInnerHTML={{ __html: decodedTitle }}
                />
            </Card.Body>
        </Card>
    );
}

export default StreamCard;
